/* VERSION_CARLOS — Modo instituto.
   Todas las clases de un centro (colección con plantilla "centro") suman para el tramo de precio.
   Pinta: contador de clases, precio conjunto, siguiente tramo, escalera de desbloqueos y ranking por % pagado.
   Datos: <script type="application/json" data-centro-json> dentro de cada [data-centro]. */
(function () {
  'use strict';
  var C = window.CUSTOMLY || {};
  function eur(v) { return v.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function tiersFor(prenda) {
    var g = (C.garments || {})[prenda] || (C.garments || {}).hoodie || {}, t = [];
    try { t = (typeof g.pricingRaw === 'string' ? JSON.parse(g.pricingRaw) : g.pricingRaw) || []; } catch (e) {}
    return t.map(function (x) { return { min: +x.min, max: +x.max, p: +(x.precio != null ? x.precio : x.price) }; })
      .filter(function (x) { return x.p > 0; }).sort(function (a, b) { return a.min - b.min; });
  }
  function tierAt(tiers, n) { for (var i = 0; i < tiers.length; i++) if (n >= tiers[i].min && n <= tiers[i].max) return i; return -1; }
  function unlocks(raw) {
    return String(raw || '').split(/\n/).map(function (l) { var m = l.split('|'); return { n: parseInt(m[0], 10), t: (m.slice(1).join('|') || '').trim() }; })
      .filter(function (u) { return u.n > 0 && u.t; });
  }
  /* Escalera: tramos de precio + desbloqueos, ordenados por número de prendas */
  function ladder(tiers, ul, base) {
    var rows = [];
    tiers.forEach(function (t, i) { if (i > 0 && t.p < tiers[i - 1].p && t.min > base) rows.push({ n: t.min, t: 'El precio baja a <strong>' + eur(t.p) + '</strong> para todos', price: true }); });
    ul.forEach(function (u) { rows.push({ n: u.n, t: esc(u.t) }); });
    return rows.sort(function (a, b) { return a.n - b.n || (b.price ? 1 : 0) - (a.price ? 1 : 0); });
  }
  window.CustomlyCentro = { tiers: tiersFor, tierAt: tierAt, unlocks: unlocks, ladder: ladder, eur: eur };

  function render(root) {
    var D; try { D = JSON.parse(root.querySelector('[data-centro-json]').textContent); } catch (e) { return; }
    var cls = (D.clases || []).filter(function (c) { return c && c.t > 0; });
    var tiers = tiersFor(D.prenda || 'hoodie'), ul = unlocks(D.desbloqueos);
    var paid = cls.reduce(function (s, c) { return s + (+c.p || 0); }, 0);
    var plan = cls.reduce(function (s, c) { return s + (+c.t || 0); }, 0);
    var esperadas = Math.max(+D.esperadas || 0, cls.length);
    var ci = tierAt(tiers, paid), cur = ci >= 0 ? tiers[ci] : null;
    var next = null; for (var i = Math.max(ci + 1, 0); i < tiers.length; i++) { if (!cur || tiers[i].p < cur.p) { next = tiers[i]; break; } }
    if (!cur && tiers.length && paid < tiers[0].min) next = tiers[0];
    var pi = tierAt(tiers, plan), planP = pi >= 0 ? tiers[pi].p : null;
    var solo = null; cls.forEach(function (c) { var k = tierAt(tiers, c.t); if (k >= 0 && (solo == null || tiers[k].p > solo)) solo = tiers[k].p; });
    var set = function (sel, html) { var el = root.querySelector(sel); if (el) { el.innerHTML = html; el.hidden = false; } };

    set('[data-c-clases]', '<strong>' + cls.length + '</strong> de ' + esperadas + ' clases');
    var dots = ''; for (var d = 0; d < esperadas; d++) dots += '<span class="' + (d < cls.length ? 'is-on' : '') + '"></span>';
    set('[data-c-dots]', dots);
    set('[data-c-paid]', '<strong>' + paid + '</strong> prendas pagadas' + (plan > paid ? ' de ' + plan + ' previstas' : ''));
    if (cur) set('[data-c-price]', eur(cur.p) + '<small>por prenda, para todas las clases</small>');
    if (next) {
      var falta = next.min - paid;
      set('[data-c-next]', 'Con <strong>' + falta + ' más</strong> (' + next.min + ' prendas) baja a <strong>' + eur(next.p) + '</strong> para todos' + (D.garantia ? ', y quien ya haya pagado recibe la diferencia.' : '.'));
      var from = cur ? cur.min - 1 : 0, w = Math.max(4, Math.min(100, (paid - from) / Math.max(1, next.min - from) * 100));
      set('[data-c-bar]', '<span style="width:' + w.toFixed(1) + '%"></span>');
    } else if (cur) {
      set('[data-c-next]', '<strong>¡Precio mínimo alcanzado!</strong> A partir de aquí cada prenda suma desbloqueos para todo el centro.');
      set('[data-c-bar]', '<span style="width:100%"></span>');
    }
    if (solo != null && planP != null && solo > planP) {
      set('[data-c-save]', 'Si pagan todas las previstas (' + plan + '), cada uno ahorra <strong>' + eur(solo - planP) + '</strong> frente a pedir una clase sola. Entre todos, <strong>' + eur((solo - planP) * plan) + '</strong>.');
    }

    /* escalera */
    var L = ladder(tiers, ul, cls.length ? Math.min.apply(null, cls.map(function (c) { return c.t; })) : 0);
    if (L.length) {
      set('[data-c-ladder]', L.map(function (r) {
        var ok = paid >= r.n;
        return '<li class="' + (ok ? 'is-done' : (r.n - paid <= 15 ? 'is-near' : '')) + '"><b>' + r.n + '</b><span>' + r.t + '</span><i>' + (ok ? 'Desbloqueado' : 'faltan ' + (r.n - paid)) + '</i></li>';
      }).join(''));
    }

    /* ranking por % pagado */
    var rk = cls.map(function (c) { return { n: c.n, p: +c.p || 0, t: +c.t || 0, u: c.u, me: c.me, pct: c.t ? Math.min(100, Math.round((+c.p || 0) * 100 / c.t)) : 0 }; })
      .sort(function (a, b) { return b.pct - a.pct || b.p - a.p; });
    set('[data-c-rank]', rk.map(function (c, i) {
      return '<li class="' + (c.me ? 'is-me' : '') + '"><b>' + (i + 1) + '</b><span class="c-rank__n">' + esc(c.n) + (c.me ? ' <em>tu clase</em>' : '') + '</span>' +
        '<span class="c-rank__bar"><span style="width:' + c.pct + '%"></span></span><span class="c-rank__p">' + c.pct + ' %<small>' + c.p + '/' + c.t + '</small></span>' +
        (D.links && c.u && !c.me ? '<a class="c-rank__go" href="' + esc(c.u) + '">Pagar</a>' : '') + '</li>';
    }).join(''));
    var me = rk.filter(function (c) { return c.me; })[0];
    if (me) {
      var pos = rk.indexOf(me) + 1;
      set('[data-c-me]', pos === 1 ? 'Tu clase va <strong>1.ª</strong> del centro. ¡Que no os adelanten!' : 'Tu clase va <strong>' + pos + '.ª</strong>: os faltan <strong>' + Math.max(1, Math.floor(rk[pos - 2].pct * me.t / 100) + 1 - me.p) + '</strong> pagos para pasar a ' + esc(rk[pos - 2].n) + '.');
    }

    /* invitar a otra clase */
    root.querySelectorAll('[data-c-invite]').forEach(function (b) {
      b.addEventListener('click', function () {
        var t = 'Ey, estamos haciendo la sudadera de la promo de ' + D.nombre + ' con Customly. Si nos juntamos todas las clases, nos baja a todos el precio' +
          (next ? ' (con ' + (next.min - paid) + ' más, a ' + eur(next.p) + ')' : '') + '. Cada clase puede cambiar el color y poner su letra, y cada uno paga lo suyo.\nMira cómo va: ' + D.url +
          (D.cierre ? '\nCerramos el ' + D.cierre + '.' : '');
        if (navigator.share && /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent)) navigator.share({ text: t }).catch(function () {});
        else window.open('https://wa.me/?text=' + encodeURIComponent(t), '_blank');
        if (window.dataLayer) window.dataLayer.push({ event: 'centro_invite', centro: D.handle, clases: cls.length, pagadas: paid });
      });
    });
    root.querySelectorAll('[data-c-join]').forEach(function (b) {
      b.href = 'https://wa.me/' + (C.whatsapp || '') + '?text=' + encodeURIComponent('Hola, somos de otra clase de ' + D.nombre + ' y queremos sumarnos al pedido del instituto (' + D.handle + '). Somos [número] en [clase].');
    });
    root.hidden = false;
  }
  function boot() { document.querySelectorAll('[data-centro]').forEach(render); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
